import React, { useContext, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormControl from 'react-bootstrap/FormControl';
import FormLabel from 'react-bootstrap/FormLabel';

import { NCRContext } from "views";

import { File } from 'components/form/prototypes'

const FileDownloads = () => {

  const { state, setState } = useContext(NCRContext);
  const [fileHtml, setFileHtml] = useState([]);

  /**
   * The use affect loads all the files linked to the given ncr
   */
  useEffect(() => {
    setFileHtml(
      state.ncr.files.map(file => {
        let uuid = uuidv4();
        file.uuid = uuid;
        return (
          <File
            id={uuid}
            key={uuid}
            ncrId={state.ncr.id}
            upload={false}
            file={file}
          />
        )
      })
    );
  }, [setState, state.ncr.files, state.ncr.id]);

  return (
    <>
      <FormLabel>Downloads:</FormLabel>
      {fileHtml.length > 0
        ?
        fileHtml
        :
        <Row>
          <Col>
            <FormControl defaultValue='No files to download' disabled />
          </Col>
        </Row>
      }
    </>
  )
}

export { FileDownloads };
